// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,600);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{font-family:\"Open Sans\",sans-serif}.is-danger{clear:both;color:red;display:block}.is-danger,p{font-size:14px}p{line-height:20px}h2.center,p.center{text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
